import SvgIcon from '@cohort/merchants/components/Svg';
import React from 'react';

const CohortLogo: React.FC = () => (
  <div className="flex items-baseline">
    <SvgIcon style={{marginRight: 60, height: '28px'}} name="CohortLogo" height={66} />
  </div>
);
export default CohortLogo;
